import { gql } from 'apollo-boost';
import { CORE_CFDI_COMPLETE_FIELDS, COTIZACION_COMPLETE_FIELDS } from './graphql/graphql.cfdi.fragment';


export const graphqlSchema = {
    PROFILE: {
        cicleStats: gql`
        query CicleStats{
            cicleStats{
                totalBilled {
                    total
                    totalBills
                    totalPayments
                    totalCreditNotes
                }
                taxDue {
                    totalTax
                    iepsTax
                    ivaTax
                    isrTax
                }
            }
        }`,
        getBillingAccount: gql`
        query GetBillingAccount {
            getBillingAccount {
                userId
                lastPayment
                lastPaymentId
                balance
                enabled
                isClusterType
                clusterName
                hasStripeSubscription
                stripeSubscriptionStatus
                stripeSubscriptionGracePeriodEnd
                stripeSubscriptionMaxedOut
                stripeSubscriptionCfdiUsage {
                    maxUsage
                    currentUsage
                    isMeteredBilling
                    periodStartsAt
                    periodEndsAt
                    priceName
                    priceId
                }
                latestInvoicePaymentLink
            }
        }`,
        me: gql`
        query getMe{
            me {
                linkSignature
                professionalProfile {
                    companyName
                    cnktId
                    stripeCustomerId
                    authToken
                    linkerId
                    email
                    emailValid
                    createdAt
                    lastActivityAt
                    planType
                    trialExpires
                }
                fiscalpopProfile {
                    rfc
                    regimenFiscal
                    nombre
                    isProduction
                    lugarExpedicion
                    logoUrl
                }
                fiscalpopProfileStatus {
                    modulusMatch
                    cerModulus
                    cerNumber
                    notAfter
                    notBefore
                    keyModulus
                }
                billing {
                    userId
                    lastPayment
                    lastPaymentId
                    balance
                    enabled
                    isClusterType
                    clusterName
                    hasStripeSubscription
                    stripeSubscriptionStatus
                    stripeSubscriptionGracePeriodEnd
                    stripeSubscriptionMaxedOut
                    stripeSubscriptionCfdiUsage {
                        maxUsage
                        currentUsage
                        isMeteredBilling
                        periodStartsAt
                        periodEndsAt
                        priceName
                        priceId
                    }
                    latestInvoicePaymentLink
                }
            }
        }`,
        login: gql`
        mutation Login($login:AccountLogin!) {
            login(login: $login){
                professionalProfile {
                    companyName
                    cnktId
                    authToken
                    linkerId
                    email
                    emailValid
                    createdAt
                    lastActivityAt
                }
                token
            }
        }`,
        changePasswordToken: gql`
        mutation ChangePasswordToken($currentPassword: String!, $password: String!) {
            changePasswordToken(currentPassword: $currentPassword, password: $password)
        }`,
        recoverPassword: gql`
        mutation RecoverPassword($email:String!) {
            recoverPassword(email: $email)
        }`,
        validateToken: gql`
        mutation ValidateToken($token: String!) {
            validateToken(token: $token)
        }`,
        resetPasswordToken: gql`
        mutation ResetPasswordToken($token: String!, $password: String!) {
            resetPasswordToken(token: $token, password: $password){
                professionalProfile {
                    companyName
                    cnktId
                    authToken
                    linkerId
                    email
                    emailValid
                    createdAt
                    lastActivityAt
                }
                token
            }
        }`,
        SETUP: {
            registerEmisorOnly: gql`
            mutation RegisterEmisorOnly($emisor: EmisorChange!) {
                registerEmisorOnly(emisor: $emisor){
                    professionalProfile {
                        companyName
                        cnktId
                        authToken
                        linkerId
                        email
                        emailValid
                        createdAt
                        lastActivityAt
                    }
                    token
                }
            }`,
            registerAccount: gql`
            mutation RegisterAccount($client: AccountRegistration!) {
                registerAccount(client: $client){
                    professionalProfile {
                        companyName
                        cnktId
                        authToken
                        linkerId
                        email
                        emailValid
                        createdAt
                        lastActivityAt
                    }
                    token
                }
            }`,
            updateEmisor: gql`
            mutation UpdateEmisor($emisor: EmisorChange){
                updateEmisor(emisor: $emisor){
                    nombre
                    rfc
                    regimenFiscal
                    lugarExpedicion
                }
            }`,
            // cotizaciones: deprecated
            registerStripeClient: gql`
            mutation RegisterStripeClient{
                registerStripeClient
            }`,

        },
        CATALOGOS: {
            getAllTrackers: gql`
            query GetAllTrackers{
                getAllTrackers{
                    _id
                    authToken
                    folio
                    serie
                    receptorRfc
                }
            }`,
            saveCatalogoReceptor: gql`
            mutation SaveCatalogoReceptor($receptor: ReceptorInput){
                saveCatalogoReceptor(receptor: $receptor){
                    _id
                    rfc
                    name
                    email
                    regimen
                    zip
                    seriePreference
                }
            }`,
            updateCatalogoReceptor: gql`
            mutation UpdateCatalogoReceptor($receptor: ReceptorInput){
                updateCatalogoReceptor(receptor: $receptor){
                    _id
                    rfc
                    name
                    email
                    regimen
                    zip
                    seriePreference
                }
            }`,
            getClientCatalog: gql`
            query GetClientCatalog{
                getClientCatalog{
                    _id
                    rfc
                    name
                    email
                    zip
                    regimen
                    seriePreference
                }
            }`,
            getClienteByName: gql`
            query GetClienteByName($name: String){
                getClienteByName(name: $name){
                    _id
                    rfc
                    name
                    email
                    zip
                    regimen
                    seriePreference
                }
            }`,
            getClienteByRfc: gql`
            query GetClienteByRfc($rfc: String){
                getClienteByRfc(rfc: $rfc){
                    _id
                    rfc
                    name
                    email
                    zip
                    regimen
                    seriePreference
                }
            }`,
            saveCatalogoConcepto: gql`
            mutation SaveCatalogoConcepto($concepto: ConceptoInput){
                saveCatalogoConcepto(concepto: $concepto){
                    _id
                    claveProdServ
                    claveUnidad
                    descripcion
                    valorUnitario
                    pedimento
                    noIdentificacion
                    impuestos {
                        type
                        tipo
                        retencion
                        tasa
                        cuota
                        exento
                        _uniqueId
                    }
                }
            }`,
            updateCatalogoConcepto: gql`
            mutation UpdateCatalogoConcepto($concepto: ConceptoInput){
                updateCatalogoConcepto(concepto: $concepto){
                    _id
                    claveProdServ
                    claveUnidad
                    descripcion
                    valorUnitario
                    pedimento
                    noIdentificacion
                    impuestos {
                        type
                        tipo
                        retencion
                        tasa
                        cuota
                        exento
                        _uniqueId
                    }
                }
            }`,
            getConceptoCatalog: gql`
            query GetConceptoCatalog{
                getConceptoCatalog{
                    _id
                    claveProdServ
                    claveUnidad
                    descripcion
                    valorUnitario
                    pedimento
                    noIdentificacion
                    impuestos {
                        type
                        tipo
                        retencion
                        tasa
                        cuota
                        exento
                        _uniqueId
                    }
                }
            }`,
            getConceptoByName: gql`
            query GetConceptoByName($name: String){
                getConceptoByName(name: $name){
                    _id
                    claveProdServ
                    claveUnidad
                    descripcion
                    valorUnitario
                    pedimento
                    noIdentificacion
                    impuestos {
                        type
                        tipo
                        retencion
                        tasa
                        cuota
                        exento
                        _uniqueId
                    }
                }
            }`,
        },
        NOTIFICATIONS: {
            getNotifications: gql`
            query GetNotifications($resourceTypes: [String]) {
                getNotifications(resourceTypes: $resourceTypes) {
                    _id
                    profileId
                    label
                    createdAt
                    resourceType
                    level
                    read
                    resourceId
                    endpointUrl
                }
            }`,
            getWebServiceNotification: gql`
            query GetWebServiceNotification {
                getWebServiceNotification {
                    _id
                    accepts
                    label
                    onCredentialExpires
                    onCsdExpires
                    onCotizationPaid
                }
            }
            `,
            modifyWebServiceNotification: gql`
            mutation ModifyWebServiceNotification($config: WebServiceConfig!) {
                modifyWebServiceNotification(config: $config) {
                    _id
                    accepts
                    label
                    onCredentialExpires
                    onCsdExpires
                    onCotizationPaid
                }
            }
            `,
            saveServiceWorkerSubscription: gql`
            mutation SaveServiceWorkerSubscription($subscription: WebServiceSubscription!) {
                saveServiceWorkerSubscription(subscription: $subscription) {
                    _id
                    accepts
                    label
                    onCredentialExpires
                    onCsdExpires
                    onCotizationPaid
                }
            }
            `,
        }
    },
    FISCALPOP: {
        STRIPE: {
            // ROOT FUNCTIONS - Previous methods for Personal Legacy
            // cotizaciones: deprecated
            fetchStripeBalance: gql`
            query FetchStripeBalance {
                fetchStripeBalance{
                    balance {
                        available {
                            amount
                            currency
                        }
                        pending{
                            amount
                            currency
                        }
                    }
                    balanceTransactions {
                        id
                        amount
                        available_on
                        created
                        currency
                        description
                        fee
                        fee_details {
                            amount
                            application
                            currency
                            description
                            type
                        }
                        net
                        reporting_category
                        status
                        type
                    }
                }
            }`,
            SUBSCRIPTIONS: {
                billingAccountUpdated: gql`
                subscription BillingAccountUpdated {
                    billingAccountUpdated {
                        updatedAt
                        billingAccountId
                        paymentId
                        message
                    }
                }`,
                billingAccountSubscriptionUpdated: gql`
                subscription BillingAccountSubscriptionUpdated {
                    billingAccountSubscriptionUpdated {
                        updatedAt
                        billingAccountId
                        subscriptionId
                        subscriptionStatus
                        message
                    }
                }`,
                speiPaymentRequested: gql`
                subscription SpeiPaymentRequested {
                    speiPaymentRequested {
                        updatedAt
                        reference
                        amountCentsRemaining
                        billingAccountId
                        paymentIntentId
                        message
                    }
                }`
            },
        },
        COTIZACION: {
            // cotizaciones: deprecated
            stampCotizacion: gql`
            mutation StampCotizacion($cotizacionId: String!, $receptor: BillReceptorInput){
                stampCotizacion(cotizacionId: $cotizacionId, receptor: $receptor){
                    _id
                    clientId
                    rfc
                    name
                    email
                    note
                    total
                    expiration
                    translateFee
                    feeTransaction
                    feeFiscalpop
                    discount
                    discountName
                    discountFormat
                    discountExpiration
                    paymentTermsOffered
                    changesRequested
                    clientAccepted
                    vendorAccepted
                    createdAt
                    wasCancelled
                    conceptos {
                        claveProdServ
                        claveUnidad
                        cantidad
                        descripcion
                        valorUnitario
                        descuento
                        pedimento
                        noIdentificacion
                        impuestos {
                            type
                            tipo
                            retencion
                            tasa
                            cuota
                            exento
                            _uniqueId
                        }
                    }
                    paid
                    paidConfirmed
                    paidConfirmUrl
                    paidAt
                    status
                    history {
                        _id
                        createdAt
                        closed
                        whom
                        event
                        title
                        message
                        approved
                        applicableConcepts {
                            title
                            quantity
                        }
                    }
                    uuid
                    clientStamped
                    billArgumentId
                }
            }`,
            // cotizaciones: deprecated
            cancelCotizacion: gql`
            mutation CancelCotizacion($cotizacionId: String!){
                cancelCotizacion(cotizacionId: $cotizacionId){
                    _id
                    clientId
                    rfc
                    name
                    email
                    note
                    total
                    expiration
                    translateFee
                    feeTransaction
                    feeFiscalpop
                    discount
                    discountName
                    discountFormat
                    discountExpiration
                    paymentTermsOffered
                    changesRequested
                    clientAccepted
                    vendorAccepted
                    createdAt
                    wasCancelled
                    conceptos {
                        claveProdServ
                        claveUnidad
                        cantidad
                        descripcion
                        valorUnitario
                        descuento
                        pedimento
                        noIdentificacion
                        impuestos {
                            type
                            tipo
                            retencion
                            tasa
                            cuota
                            exento
                            _uniqueId
                        }
                    }
                    paid
                    paidConfirmed
                    paidConfirmUrl
                    paidAt
                    status
                    history {
                        _id
                        createdAt
                        closed
                        whom
                        event
                        title
                        message
                        approved
                        applicableConcepts {
                            title
                            quantity
                        }
                    }
                }
            }`,
            // cotizaciones: deprecated
            approveCotizacionChanges: gql`
            mutation ApproveCotizacionChanges($historyId: String, $approval: Boolean, $message: String){
                approveCotizacionChanges(historyId: $historyId, approval: $approval, message: $message){
                    _id
                    clientId
                    rfc
                    name
                    email
                    note
                    total
                    expiration
                    translateFee
                    feeTransaction
                    feeFiscalpop
                    discount
                    discountName
                    discountFormat
                    discountExpiration
                    paymentTermsOffered
                    changesRequested
                    clientAccepted
                    vendorAccepted
                    createdAt
                    wasCancelled
                    conceptos {
                        claveProdServ
                        claveUnidad
                        cantidad
                        descripcion
                        valorUnitario
                        descuento
                        pedimento
                        noIdentificacion
                        impuestos {
                            type
                            tipo
                            retencion
                            tasa
                            cuota
                            exento
                            _uniqueId
                        }
                    }
                    paid
                    paidConfirmed
                    paidConfirmUrl
                    paidAt
                    status
                    history {
                        _id
                        createdAt
                        closed
                        whom
                        event
                        title
                        message
                        approved
                        applicableConcepts {
                            title
                            quantity
                        }
                    }
                }
            }`,
            // cotizaciones: deprecated
            requestCotizacionChanges: gql`
            mutation RequestCotizacionChanges($entry: CotizacionHistoryInput){
                requestCotizacionChanges(entry: $entry){
                    _id
                    clientId
                    rfc
                    name
                    email
                    note
                    total
                    expiration
                    translateFee
                    feeTransaction
                    feeFiscalpop
                    discount
                    discountName
                    discountFormat
                    discountExpiration
                    paymentTermsOffered
                    changesRequested
                    clientAccepted
                    vendorAccepted
                    createdAt
                    wasCancelled
                    conceptos {
                        claveProdServ
                        claveUnidad
                        cantidad
                        descripcion
                        valorUnitario
                        descuento
                        pedimento
                        noIdentificacion
                        impuestos {
                            type
                            tipo
                            retencion
                            tasa
                            cuota
                            exento
                            _uniqueId
                        }
                    }
                    paid
                    paidConfirmed
                    paidConfirmUrl
                    paidAt
                    status
                    history {
                        _id
                        createdAt
                        closed
                        whom
                        event
                        title
                        message
                        approved
                        applicableConcepts {
                            title
                            quantity
                        }
                    }
                }
            }`,
            // cotizaciones: deprecated
            confirmIntent: gql`
            mutation ConfirmIntent($cotizacionId: String!, $intentId: String, $installments:Float){
                confirmIntent(cotizacionId: $cotizacionId, intentId: $intentId, installments: $installments){
                    success
                    intentId
                    needsConfirm
                    plansAreAvailable
                    status
                    plansAvailable {
                        count
                        interval
                        type
                    }
                }
            }
            `,
            // cotizaciones: deprecated
            setPaymentIntent: gql`
            mutation SetPaymentIntent($cotizacionId: String!, $installments: Float, $paymentMethodId: String){
                setPaymentIntent(cotizacionId: $cotizacionId, installments: $installments, paymentMethodId: $paymentMethodId){
                    success
                    intentId
                    needsConfirm
                    plansAreAvailable
                    status
                    plansAvailable {
                        count
                        interval
                        type
                    }
                }
            }
            `,
            // cotizaciones: deprecated
            fetchCotizacionesByDate: gql`
            query FetchCotizacionesByDate($start: Float, $end: Float){
                fetchCotizacionesByDate(start: $start, end: $end){
                    _id
                    clientId
                    rfc
                    name
                    email
                    note
                    total
                    expiration
                    translateFee
                    feeTransaction
                    feeFiscalpop
                    discount
                    discountName
                    discountFormat
                    discountExpiration
                    paymentTermsOffered
                    changesRequested
                    clientAccepted
                    vendorAccepted
                    createdAt
                    wasCancelled
                    conceptos {
                        claveProdServ
                        claveUnidad
                        cantidad
                        descripcion
                        valorUnitario
                        descuento
                        pedimento
                        noIdentificacion
                        impuestos {
                            type
                            tipo
                            retencion
                            tasa
                            cuota
                            exento
                            _uniqueId
                        }
                    }
                    paid
                    paidConfirmed
                    paidConfirmUrl
                    paidAt
                    status
                    uuid
                }
            }`,
            // cotizaciones: deprecated
            fetchCotizaciones: gql`
            query FetchCotizaciones{
                fetchCotizaciones{
                    _id
                    clientId
                    rfc
                    name
                    email
                    note
                    total
                    expiration
                    translateFee
                    feeTransaction
                    feeFiscalpop
                    discount
                    discountName
                    discountFormat
                    discountExpiration
                    paymentTermsOffered
                    changesRequested
                    clientAccepted
                    vendorAccepted
                    createdAt
                    wasCancelled
                    conceptos {
                        claveProdServ
                        claveUnidad
                        cantidad
                        descripcion
                        valorUnitario
                        descuento
                        pedimento
                        noIdentificacion
                        impuestos {
                            type
                            tipo
                            retencion
                            tasa
                            cuota
                            exento
                            _uniqueId
                        }
                    }
                    paid
                    paidConfirmed
                    paidConfirmUrl
                    paidAt
                    status
                    uuid
                }
            }`,
            // cotizaciones: deprecated
            fetchOpenCotizaciones: gql`
            ${COTIZACION_COMPLETE_FIELDS}
            query FetchOpenCotizaciones{
                fetchOpenCotizaciones{
                    ...CotizacionCompleteFields
                }
            }`,
            // cotizaciones: deprecated
            fetchCotizacion: gql`
            query FetchCotizacion($cotizacionId: String!){
                fetchCotizacion(cotizacionId: $cotizacionId){
                    cotizacion {
                        _id
                        clientId
                        rfc
                        name
                        email
                        note
                        total
                        expiration
                        translateFee
                        feeTransaction
                        feeFiscalpop
                        discount
                        discountName
                        discountFormat
                        discountExpiration
                        paymentTermsOffered
                        changesRequested
                        clientAccepted
                        vendorAccepted
                        createdAt
                        wasCancelled
                        conceptos {
                            claveProdServ
                            claveUnidad
                            cantidad
                            descripcion
                            valorUnitario
                            descuento
                            pedimento
                            noIdentificacion
                            impuestos {
                                type
                                tipo
                                retencion
                                tasa
                                cuota
                                exento
                                _uniqueId
                            }
                        }
                        paid
                        paidConfirmed
                        paidConfirmUrl
                        paidAt
                        status
                        history {
                            _id
                            createdAt
                            closed
                            whom
                            event
                            title
                            message
                            approved
                            applicableConcepts {
                                title
                                quantity
                            }
                        }
                        uuid
                        clientStamped
                        billArgumentId
                    }
                    fiscalpop {
                        rfc
                        regimenFiscal
                        nombre
                        lugarExpedicion
                        logoUrl
                    }
                    profile {
                        _id
                        token
                        companyName
                        email
                    }
                }
            }`,
            // cotizaciones: deprecated
            generateCotizacion: gql`
            mutation GenerateCotizacion($cotizacion: CotizacionInput!){
                generateCotizacion(cotizacion: $cotizacion){
                    _id
                    clientId
                    rfc
                    name
                    email
                    note
                    total
                    expiration
                    translateFee
                    feeTransaction
                    feeFiscalpop
                    discount
                    discountName
                    discountFormat
                    discountExpiration
                    paymentTermsOffered
                    clientAccepted
                    vendorAccepted
                    createdAt
                    status
                    conceptos {
                        claveProdServ
                        claveUnidad
                        cantidad
                        descripcion
                        valorUnitario
                        descuento
                        pedimento
                        noIdentificacion
                        impuestos {
                            type
                            tipo
                            retencion
                            tasa
                            cuota
                            exento
                            _uniqueId
                        }
                    }
                }
            }`,
            // cotizaciones: deprecated
            manuallySetCotizacionAsPaid: gql`
                mutation ManuallySetCotizacionAsPaid($cotizacionId: String!, $paymentMethod: String){
                    manuallySetCotizacionAsPaid(cotizacionId: $cotizacionId, paymentMethod: $paymentMethod){
                        _id
                        clientId
                        rfc
                        name
                        email
                        note
                        total
                        expiration
                        translateFee
                        feeTransaction
                        feeFiscalpop
                        discount
                        discountName
                        discountFormat
                        discountExpiration
                        paymentTermsOffered
                        clientAccepted
                        vendorAccepted
                        createdAt
                        status
                        conceptos {
                            claveProdServ
                            claveUnidad
                            cantidad
                            descripcion
                            valorUnitario
                            descuento
                            pedimento
                            noIdentificacion
                            impuestos {
                                type
                                tipo
                                retencion
                                tasa
                                cuota
                                exento
                                _uniqueId
                            }
                        }
                    }
                }`
        },
        CFDI: {
            setBillToCancel: gql`
            mutation SetBillToCancel($uuid: String, $billArgumentId: String){
                setBillToCancel(uuid: $uuid, billArgumentId: $billArgumentId) {
                    folios {
                        uuid
                        estatus
                    }
                }
            }`,
            getOpenBillArgumentsByRFC: gql`
            ${CORE_CFDI_COMPLETE_FIELDS}
            query GetOpenBillArgumentsByRFC($rfc: String, $argumentId: String){
                getOpenBillArgumentsByRFC(rfc: $rfc, argumentId: $argumentId){
                    pendingPayment
                    argument {
                        _id
                        authToken
                        multipayType
                        profileId
                        timeDefered
                        multiPayments
                        upfront
                        frequency
                        wasCanceled
                        wasMuted
                        specialType
                        MasterCFDI {
                            ...MasterCfdiCompleteFields
                        }
                        uuid
                        isClosed
                        createdAt
                        billEvents {
                            _id
                            argumentId
                            authToken
                            isClosed
                            when
                            wasCanceled
                            wasMuted
                            closedAt
                            type
                            uuid
                            notaUUID
                            paymentNum
                            CFDI {
                                serie
                                folio
                                formaPago
                                metodoPago
                                lugarExpedicion
                                tipoDeComprobante
                                receptor {
                                    customerId
                                    nombre
                                    rfc
                                    usoCFDI
                                    zip
                                    regimen
                                    email
                                    emailCC
                                }
                                conceptos {
                                    claveProdServ
                                    claveUnidad
                                    cantidad
                                    descripcion
                                    valorUnitario
                                    descuento
                                    pedimento
                                    noIdentificacion
                                    impuestos {
                                        type
                                        tipo
                                        retencion
                                        tasa
                                        cuota
                                        exento
                                        _uniqueId
                                    }
                                }
                                cfdiRelacionados {
                                    tipoRelacion
                                    uuids
                                }
                            }
                            NotaCreditoCFDI {
                                serie
                                folio
                                formaPago
                                metodoPago
                                lugarExpedicion
                                tipoDeComprobante
                                receptor {
                                    customerId
                                    nombre
                                    rfc
                                    usoCFDI
                                    zip
                                    regimen
                                    email
                                    emailCC
                                }
                                conceptos {
                                    claveProdServ
                                    claveUnidad
                                    cantidad
                                    descripcion
                                    valorUnitario
                                    descuento
                                    pedimento
                                    noIdentificacion
                                    impuestos {
                                        type
                                        tipo
                                        retencion
                                        tasa
                                        cuota
                                        exento
                                        _uniqueId
                                    }
                                }
                                cfdiRelacionados {
                                    tipoRelacion
                                    uuids
                                }
                            }
                        }
                        paymentEvents {
                            _id
                            argumentId
                            authToken
                            isClosed
                            when
                            wasCanceled
                            wasMuted
                            closedAt
                            type
                            uuid
                            paymentNum
                            paymentCFDI {
                                lugarExpedicion
                                serie
                                receptor {
                                    customerId
                                    nombre
                                    rfc
                                    usoCFDI
                                    zip
                                    regimen
                                    email
                                    emailCC
                                }
                                pagos {
                                    fecha
                                    formaDePago
                                    moneda
                                    tipoCambio
                                    monto
                                    rfcBanco
                                    numOperacion
                                    bancoOrdenante
                                    cuentaOrdenante
                                    cuentaBeneficiario
                                    facturaRelacionada {
                                        uuid
                                        importePagado
                                        numParcialidad
                                    }
                                }
                            }       
                        }
                    }
                }
            }
            `,
            getAllBillArgumentsByQuery: gql`
            ${CORE_CFDI_COMPLETE_FIELDS}
            query GetAllBillArgumentsByQuery($start:Float, $end:Float, $uuid: String, $rfc: String){
                getAllBillArgumentsByQuery(start:$start, end:$end, uuid: $uuid, rfc: $rfc){
                    cfdi {
                        created
                        uuid
                        paymentUUIDs
                        authToken
                        status
                        cancelling
                        sandbox
                        email
                        total
                        paymentTotal
                        isPayment
                        rfc
                        nombre
                        serie
                        folio
                    }
                    argument {
                        _id
                        authToken
                        multipayType
                        profileId
                        timeDefered
                        multiPayments
                        upfront
                        frequency
                        wasCanceled
                        wasMuted
                        specialType
                        MasterCFDI {
                            ...MasterCfdiCompleteFields
                        }
                        uuid
                        rfcTarget
                        isClosed
                        createdAt
                        billEvents {
                            _id
                            argumentId
                            authToken
                            isClosed
                            when
                            wasCanceled
                            wasMuted
                            closedAt
                            type
                            uuid
                            notaUUID
                            paymentNum
                            CFDI {
                                serie
                                folio
                                formaPago
                                metodoPago
                                lugarExpedicion
                                tipoDeComprobante
                                receptor {
                                    customerId
                                    nombre
                                    rfc
                                    usoCFDI
                                    zip
                                    regimen
                                    email
                                    emailCC
                                }
                                conceptos {
                                    claveProdServ
                                    claveUnidad
                                    cantidad
                                    descripcion
                                    valorUnitario
                                    descuento
                                    pedimento
                                    noIdentificacion
                                    impuestos {
                                        type
                                        tipo
                                        retencion
                                        tasa
                                        cuota
                                        exento
                                        _uniqueId
                                    }
                                }
                                cfdiRelacionados {
                                    tipoRelacion
                                    uuids
                                }
                            }
                            NotaCreditoCFDI {
                                serie
                                folio
                                formaPago
                                metodoPago
                                lugarExpedicion
                                tipoDeComprobante
                                receptor {
                                    customerId
                                    nombre
                                    rfc
                                    usoCFDI
                                    zip
                                    regimen
                                    email
                                    emailCC
                                }
                                conceptos {
                                    claveProdServ
                                    claveUnidad
                                    cantidad
                                    descripcion
                                    valorUnitario
                                    descuento
                                    pedimento
                                    noIdentificacion
                                    impuestos {
                                        type
                                        tipo
                                        retencion
                                        tasa
                                        cuota
                                        exento
                                        _uniqueId
                                    }
                                }
                                cfdiRelacionados {
                                    tipoRelacion
                                    uuids
                                }
                            }
                        }
                        paymentEvents {
                            _id
                            argumentId
                            authToken
                            isClosed
                            when
                            wasCanceled
                            wasMuted
                            closedAt
                            type
                            uuid
                            paymentNum
                            paymentCFDI {
                                fecha
                                lugarExpedicion
                                serie
                                receptor {
                                    customerId
                                    nombre
                                    rfc
                                    usoCFDI
                                    zip
                                    regimen
                                    email
                                    emailCC
                                }
                                pagos {
                                    fecha
                                    formaDePago
                                    moneda
                                    tipoCambio
                                    monto
                                    rfcBanco
                                    numOperacion
                                    bancoOrdenante
                                    cuentaOrdenante
                                    cuentaBeneficiario
                                    facturaRelacionada {
                                        uuid
                                        importePagado
                                        numParcialidad
                                    }
                                }
                            }
                            
                        }
                    }
                }
            }
            `,
            getAllBillArguments: gql`
            ${CORE_CFDI_COMPLETE_FIELDS}
            query GetAllBillArguments($start:Float, $end:Float){
                getAllBillArguments(start:$start, end:$end){
                    _id
                    authToken
                    multipayType
                    profileId
                    timeDefered
                    multiPayments
                    upfront
                    frequency
                    wasCanceled
                    wasMuted
                    specialType
                    MasterCFDI {
                        ...MasterCfdiCompleteFields
                    }
                    uuid
                    rfcTarget
                    specialType
                    isClosed
                    createdAt
                    billEvents {
                        _id
                        argumentId
                        authToken
                        isClosed
                        when
                        wasCanceled
                        wasMuted
                        closedAt
                        type
                        uuid
                        notaUUID
                        paymentNum
                        CFDI {
                            serie
                            folio
                            formaPago
                            metodoPago
                            lugarExpedicion
                            tipoDeComprobante
                            receptor {
                                customerId
                                nombre
                                rfc
                                usoCFDI
                                zip
                                regimen
                                email
                                emailCC
                            }
                            conceptos {
                                claveProdServ
                                claveUnidad
                                cantidad
                                descripcion
                                valorUnitario
                                descuento
                                pedimento
                                noIdentificacion
                                impuestos {
                                    type
                                    tipo
                                    retencion
                                    tasa
                                    cuota
                                    exento
                                    _uniqueId
                                }
                            }
                            cfdiRelacionados {
                                tipoRelacion
                                uuids
                            }
                        }
                        NotaCreditoCFDI {
                            serie
                            folio
                            formaPago
                            metodoPago
                            lugarExpedicion
                            tipoDeComprobante
                            receptor {
                                customerId
                                nombre
                                rfc
                                usoCFDI
                                zip
                                regimen
                                email
                                emailCC
                            }
                            conceptos {
                                claveProdServ
                                claveUnidad
                                cantidad
                                descripcion
                                valorUnitario
                                descuento
                                pedimento
                                noIdentificacion
                                impuestos {
                                    type
                                    tipo
                                    retencion
                                    tasa
                                    cuota
                                    exento
                                    _uniqueId
                                }
                            }
                            cfdiRelacionados {
                                tipoRelacion
                                uuids
                            }
                        }
                    }
                    paymentEvents {
                        _id
                        argumentId
                        authToken
                        isClosed
                        when
                        wasCanceled
                        wasMuted
                        closedAt
                        type
                        uuid
                        paymentNum
                        paymentCFDI {
                            fecha
                            lugarExpedicion
                            serie
                            receptor {
                                customerId
                                nombre
                                rfc
                                usoCFDI
                                zip
                                regimen
                                email
                                emailCC
                            }
                            pagos {
                                fecha
                                formaDePago
                                moneda
                                tipoCambio
                                monto
                                rfcBanco
                                numOperacion
                                bancoOrdenante
                                cuentaOrdenante
                                cuentaBeneficiario
                                facturaRelacionada {
                                    uuid
                                    importePagado
                                    numParcialidad
                                }
                            }
                        }
                        
                    }
                }
            }
            `,
            getBillsByRfc: gql`
            query GetBillsByRfc($rfc: String){
                getBillsByRfc(rfc: $rfc){
                    created
                    uuid
                    paymentUUIDs
                    json
                    xml
                    authToken
                    status
                    cancelling
                    sandbox
                    email
                    total
                    paymentTotal
                    isPayment
                    rfc
                    nombre
                }
            }`,
            getBillEventsByRfc: gql`
            ${CORE_CFDI_COMPLETE_FIELDS}
            query GetBillEventsByRfc($rfc: String){
                getBillEventsByRfc(rfc: $rfc){
                    _id
                    authToken
                    multipayType
                    profileId
                    timeDefered
                    multiPayments
                    upfront
                    frequency
                    wasCanceled
                    wasMuted
                    specialType
                    MasterCFDI {
                        ...MasterCfdiCompleteFields
                    }
                    uuid
                    isClosed
                    createdAt
                    billEvents {
                        _id
                        argumentId
                        authToken
                        isClosed
                        when
                        wasCanceled
                        wasMuted
                        closedAt
                        type
                        uuid
                        notaUUID
                        paymentNum
                        CFDI {
                            serie
                            folio
                            formaPago
                            metodoPago
                            lugarExpedicion
                            tipoDeComprobante
                            receptor {
                                customerId
                                nombre
                                rfc
                                usoCFDI
                                zip
                                regimen
                                email
                                emailCC
                            }
                            conceptos {
                                claveProdServ
                                claveUnidad
                                cantidad
                                descripcion
                                valorUnitario
                                descuento
                                pedimento
                                noIdentificacion
                                impuestos {
                                    type
                                    tipo
                                    retencion
                                    tasa
                                    cuota
                                    exento
                                    _uniqueId
                                }
                            }
                            cfdiRelacionados {
                                tipoRelacion
                                uuids
                            }
                        }
                        NotaCreditoCFDI {
                            serie
                            folio
                            formaPago
                            metodoPago
                            lugarExpedicion
                            tipoDeComprobante
                            receptor {
                                customerId
                                nombre
                                rfc
                                usoCFDI
                                zip
                                regimen
                                email
                                emailCC
                            }
                            conceptos {
                                claveProdServ
                                claveUnidad
                                cantidad
                                descripcion
                                valorUnitario
                                descuento
                                pedimento
                                noIdentificacion
                                impuestos {
                                    type
                                    tipo
                                    retencion
                                    tasa
                                    cuota
                                    exento
                                    _uniqueId
                                }
                            }
                            cfdiRelacionados {
                                tipoRelacion
                                uuids
                            }
                        }
                    }
                    paymentEvents {
                        _id
                        argumentId
                        authToken
                        isClosed
                        when
                        wasCanceled
                        wasMuted
                        closedAt
                        type
                        uuid
                        paymentNum
                        paymentCFDI {
                            fecha
                            lugarExpedicion
                            serie
                            receptor {
                                customerId
                                nombre
                                rfc
                                usoCFDI
                                zip
                                regimen
                                email
                                emailCC
                            }
                            pagos {
                                fecha
                                formaDePago
                                moneda
                                tipoCambio
                                monto
                                rfcBanco
                                numOperacion
                                bancoOrdenante
                                cuentaOrdenante
                                cuentaBeneficiario
                                facturaRelacionada {
                                    uuid
                                    importePagado
                                    numParcialidad
                                }
                            }
                        }
                        
                    }
                }
            }
            `,
            getOpenBillArguments: gql`
            ${CORE_CFDI_COMPLETE_FIELDS}
            query GetOpenBillArguments($start:Float, $end:Float){
                getOpenBillArguments(start:$start, end:$end){
                    _id
                    authToken
                    multipayType
                    profileId
                    timeDefered
                    multiPayments
                    upfront
                    frequency
                    wasCanceled
                    wasMuted
                    specialType
                    MasterCFDI {
                        ...MasterCfdiCompleteFields
                    }
                    uuid
                    isClosed
                    createdAt
                    billEvents {
                        _id
                        argumentId
                        authToken
                        isClosed
                        when
                        wasCanceled
                        wasMuted
                        closedAt
                        type
                        uuid
                        notaUUID
                        paymentNum
                        CFDI {
                            serie
                            folio
                            formaPago
                            metodoPago
                            lugarExpedicion
                            tipoDeComprobante
                            receptor {
                                customerId
                                nombre
                                rfc
                                usoCFDI
                                zip
                                regimen
                                email
                                emailCC
                            }
                            conceptos {
                                claveProdServ
                                claveUnidad
                                cantidad
                                descripcion
                                valorUnitario
                                descuento
                                pedimento
                                noIdentificacion
                                impuestos {
                                    type
                                    tipo
                                    retencion
                                    tasa
                                    cuota
                                    exento
                                    _uniqueId
                                }
                            }
                            cfdiRelacionados {
                                tipoRelacion
                                uuids
                            }
                        }
                        NotaCreditoCFDI {
                            serie
                            folio
                            formaPago
                            metodoPago
                            lugarExpedicion
                            tipoDeComprobante
                            receptor {
                                customerId
                                nombre
                                rfc
                                usoCFDI
                                zip
                                regimen
                                email
                                emailCC
                            }
                            conceptos {
                                claveProdServ
                                claveUnidad
                                cantidad
                                descripcion
                                valorUnitario
                                descuento
                                pedimento
                                noIdentificacion
                                impuestos {
                                    type
                                    tipo
                                    retencion
                                    tasa
                                    cuota
                                    exento
                                    _uniqueId
                                }
                            }
                            cfdiRelacionados {
                                tipoRelacion
                                uuids
                            }
                        }
                    }
                    paymentEvents {
                        _id
                        argumentId
                        authToken
                        isClosed
                        when
                        wasCanceled
                        wasMuted
                        closedAt
                        type
                        uuid
                        paymentNum
                        paymentCFDI {
                            fecha
                            lugarExpedicion
                            serie
                            receptor {
                                customerId
                                nombre
                                rfc
                                usoCFDI
                                zip
                                regimen
                                email
                                emailCC
                            }
                            pagos {
                                fecha
                                formaDePago
                                moneda
                                tipoCambio
                                monto
                                rfcBanco
                                numOperacion
                                bancoOrdenante
                                cuentaOrdenante
                                cuentaBeneficiario
                                facturaRelacionada {
                                    uuid
                                    importePagado
                                    numParcialidad
                                }
                            }
                        }
                        
                    }
                }
            }
            `,
            setBillEventToMute: gql`
            mutation SetBillEventToMute($billEventId: String!) {
                setBillEventToMute(billEventId: $billEventId) {
                    _id
                    wasMuted
                }
            }
            `,
            setBillEventToClosed: gql`
            mutation SetBillEventToClosed($billEventId: String!) {
                setBillEventToClosed(billEventId: $billEventId) {
                    _id
                    isClosed
                }
            }
            `,
            restampBillArgument: gql`
            ${CORE_CFDI_COMPLETE_FIELDS}
            mutation RestampBillArgument($billArgumentToEditId: String, $argument:BillArgumentsInput!, $billEvents: [BillEventInput], $paymentEvents: [BillEventInput]){
                restampBillArgument(billArgumentToEditId: $billArgumentToEditId, argument: $argument, billEvents: $billEvents, paymentEvents: $paymentEvents){
                    _id
                    authToken
                    multipayType
                    profileId
                    timeDefered
                    multiPayments
                    upfront
                    frequency
                    wasCanceled
                    wasMuted
                    specialType
                    MasterCFDI {
                        ...MasterCfdiCompleteFields
                    }
                    uuid
                    isClosed
                    createdAt
                }
            }
            `,
            restampBillEvent: gql`
            ${CORE_CFDI_COMPLETE_FIELDS}
            mutation RestampBillEvent($billEventToEditId: String, $argument:BillArgumentsInput!, $billEvents: [BillEventInput], $paymentEvents: [BillEventInput]){
                restampBillEvent(billEventToEditId: $billEventToEditId, argument: $argument, billEvents: $billEvents, paymentEvents: $paymentEvents){
                    _id
                    authToken
                    multipayType
                    profileId
                    timeDefered
                    multiPayments
                    upfront
                    frequency
                    wasCanceled
                    wasMuted
                    specialType
                    MasterCFDI {
                        ...MasterCfdiCompleteFields
                    }
                    uuid
                    isClosed
                    createdAt
                }
            }
            `,
            stampFromBillArgument: gql`
            ${CORE_CFDI_COMPLETE_FIELDS}
            mutation StampFromBillArgument($argument:BillArgumentsInput!, $billEvents: [BillEventInput], $paymentEvents: [BillEventInput]){
                stampFromBillArgument(argument: $argument, billEvents: $billEvents, paymentEvents: $paymentEvents){
                    _id
                    authToken
                    multipayType
                    profileId
                    timeDefered
                    multiPayments
                    upfront
                    frequency
                    wasCanceled
                    wasMuted
                    MasterCFDI {
                        ...MasterCfdiCompleteFields
                    }
                    uuid
                    isClosed
                    createdAt
                }
            }
            `,
            stampFromNotaCredito: gql`
            ${CORE_CFDI_COMPLETE_FIELDS}
            mutation StampFromNotaCredito($uuidRelated: String!, $cfdi: BillInput!){
                stampFromNotaCredito(uuidRelated: $uuidRelated, cfdi: $cfdi){
                    _id
                    authToken
                    multipayType
                    profileId
                    timeDefered
                    multiPayments
                    upfront
                    frequency
                    wasCanceled
                    wasMuted
                    specialType
                    MasterCFDI {
                        ...MasterCfdiCompleteFields
                    }
                    uuid
                    isClosed
                    createdAt
                }
            }
            `,
            restampBillNotaCredito: gql`
            ${CORE_CFDI_COMPLETE_FIELDS}
            mutation RestampBillNotaCredito($replaceNotaId: String!, $cfdi: BillInput!){
                restampBillNotaCredito(replaceNotaId: $replaceNotaId, cfdi: $cfdi){
                    _id
                    authToken
                    multipayType
                    profileId
                    timeDefered
                    multiPayments
                    upfront
                    frequency
                    wasCanceled
                    wasMuted
                    specialType
                    MasterCFDI {
                        ...MasterCfdiCompleteFields
                    }
                    uuid
                    isClosed
                    createdAt
                }
            }
            `,
            stampFromBillEvent: gql`
            ${CORE_CFDI_COMPLETE_FIELDS}
            mutation StampFromBillEvent($argument:BillArgumentsInput!, $cfdi: [BillEventInput]){
                stampFromBillEvent(argument: $argument, cfdi: $cfdi){
                    _id
                    authToken
                    multipayType
                    profileId
                    timeDefered
                    multiPayments
                    upfront
                    frequency
                    wasCanceled
                    wasMuted
                    specialType
                    MasterCFDI {
                        ...MasterCfdiCompleteFields
                    }
                    uuid
                    isClosed
                    createdAt
                }
            }
            `,
            stampFromPaymentEvent: gql`
            ${CORE_CFDI_COMPLETE_FIELDS}
            mutation StampFromPaymentEvent($arguments:[BillArgumentsInput], $cfdi: PaymentBillInput){
                stampFromPaymentEvent(arguments: $arguments, cfdi: $cfdi){
                    _id
                    authToken
                    multipayType
                    profileId
                    timeDefered
                    multiPayments
                    upfront
                    frequency
                    wasCanceled
                    wasMuted
                    specialType
                    MasterCFDI {
                        ...MasterCfdiCompleteFields
                    }
                    uuid
                    isClosed
                    createdAt
                }
            }
            `,
            restampBillPaymentEvent: gql`
            ${CORE_CFDI_COMPLETE_FIELDS}
            mutation RestampBillPaymentEvent($eventid: String!, $arguments:[BillArgumentsInput], $cfdi: PaymentBillInput){
                restampBillPaymentEvent(eventid: $eventid, arguments: $arguments, cfdi: $cfdi){
                    _id
                    authToken
                    multipayType
                    profileId
                    timeDefered
                    multiPayments
                    upfront
                    frequency
                    wasCanceled
                    wasMuted
                    specialType
                    MasterCFDI {
                        ...MasterCfdiCompleteFields
                    }
                    uuid
                    isClosed
                    createdAt
                }
            }
            `,
        },
        USO_CFDI: {
            getUsoCfdi: gql`
                query GetUsoCfdi{
                    getUsoCfdi{
                        clave
                        descripcion
                        forRegimen
                    }
                }
            `,
            getUsoCfdiTokenized: gql`
                query GetUsoCfdiTokenized($token: String!){
                    getUsoCfdiTokenized(token: $token){
                        clave
                        descripcion
                    }
                }
            `
        },
        FORMA_PAGO: {
            getFormaPago: gql`
                query GetFormaPago{
                    getFormaPago{
                        key
                        label
                    }
                }
            `
        },
        IMPUESTOS: {
            getImpuestos: gql`
                query GetImpuestos{
                    getImpuestos{
                        tipo
                        min
                        max
                        impuesto
                        factor
                        traslado
                        retencion
                        exento
                    }
                }
            `
        },
        SETUP: {
            setFiscalpopClient: gql`
            mutation SetFiscalpopClient($client: FiscalpopClient!){
                setFiscalpopClient(client: $client){
                    rfc
                    regimenFiscal
                    nombre
                    lugarExpedicion
                }
            }`
        },
        SUPPORT: {
            sendSupportEmail: gql`
            mutation SendSupportEmail($support: FiscalpopSupport!){
                sendSupportEmail(support: $support) {
                    success
                }
            }`
        }
    },
    PAYMENTS: {
        ORDERS: {
            getPaymentOrderRecords: gql`
            query GetPaymentOrderRecords {
                getPaymentOrderRecords {
                    type
                    gateway
                    orderId
                    amountCents
                    currency
                    isPaid
                    isRefunded
                    status
                    createdAt
                    updatedAt
                    invoiceUUID
                    refundInvoiceUUID
                }
            }`,
            getOpenSpeiPayment: gql`
            query GetOpenSpeiPayment {
                getOpenSpeiPayment {
                    paymentIntentId
                    amountCentsRemaining
                    instructionsUrl
                    reference
                }
            }
            `
        }
    },
    STRIPE: {
        PAYMENTS: {
            createPaymentIntent: gql`
            mutation CreatePaymentIntent($amount: Float!){
                createPaymentIntent(amount: $amount) {
                    client_secret
                    identifier
                    status
                    amountCents
                }
            }`,
        },
        PRICES: {
            getPricingPlans: gql`
            query GetPricingPlans {
                getPricingPlans {
                    id
                    productId
                    name
                    maxUsage
                    isMeteredBilling
                    currency
                    unitAmountCents
                    cfdiMinAmountCents
                }
            }
            `,
            getCheckoutSession: gql`
            query GetCheckoutSession($sessionId: String!) {
                getCheckoutSession(sessionId: $sessionId) {
                    id
                    url
                    status
                    amountCents
                    subscription
                }
            }
            `,
            createCheckoutSession: gql`
            mutation CreateCheckoutSession($pricingId: String!) {
                createCheckoutSession(pricingId: $pricingId) {
                    id
                    url
                    status
                    amountCents
                    subscription
                }
            }`,
            changeSubscriptionPlan: gql`
            mutation ChangeSubscriptionPlan($pricingId: String!) {
                changeSubscriptionPlan(pricingId: $pricingId)
            }`,
            cancelSubscription: gql`
            mutation CancelSubscription {
                cancelSubscription
            }`,
            getUsageByRange: gql`
            query GetUsageByRange($start: Float!, $end: Float!) {
                getUsageByRange (start: $start, end: $end) {
                    aggregatedValue
                    startTime
                    endTime
                }
            }
            `
        },
    }
}
